export interface Dashboard {
    id: string;
    name: string;
    disabled: boolean;
    timezone: string;
    uiTheme: string;
    sortBy: string | null;
    pollDelay: number;
    operatorDisplayFormat: 'icao' | 'iata';
    alerts: {
        thresholdLate: number;
        thresholdEarly: number;
    };
    filters: {
        operators: string[];
        airports: string[];
        registrations: string[];
        maximumFlights: number | null;
        showFlightsScheduledToArriveWithin: number;
        hideArrivedFlightsAfter: number;
    };
}

export function createDashboardModel(): Dashboard {
    const newDashboard: Dashboard = {
        id: '',
        name: '',
        disabled: false,
        timezone: 'utc',
        uiTheme: '',
        sortBy: 'estimatedIn-asc',
        pollDelay: 30,
        operatorDisplayFormat: 'icao',
        alerts: {
            thresholdLate: 300,
            thresholdEarly: 300,
        },
        filters: {
            operators: [],
            airports: [],
            registrations: [],
            maximumFlights: null,
            showFlightsScheduledToArriveWithin: 43200,
            hideArrivedFlightsAfter: 600,
        },
    };

    return newDashboard;
}
